import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import authSlice from "./slices/authSlice";
import selectedSubcategoriesReducer from "./slices/selectedSubcategoriesSlice";
import selectedQuestionsReducer from "./slices/selectedQuestionsSlice";
import questionTypesReducer from "./slices/questionTypesReducer";
import subcategoriesListSlice from "./slices/subcategoriesListSlice";
import questionReducer from "./reducers/question_reducer";
import resultReducer from "./reducers/result_reducer";

// Combine all reducers
const rootReducer = combineReducers({
  auth: authSlice,
  questions: questionReducer,
  result: resultReducer,
  selectedSubcategories: selectedSubcategoriesReducer,
  selectedQuestions: selectedQuestionsReducer,
  type: questionTypesReducer,
  subcategoriesList: subcategoriesListSlice,
});

// Persist config (save everything)
const persistConfig = {
  key: 'root',
  storage,
  // No whitelist/blacklist means ALL reducers will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'], // Needed for Redux-Persist
      },
    }),
});

const persistor = persistStore(store);
export { store, persistor };